import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ScopedAiLevel = 'course' | 'unit' | 'lesson';

export interface ScopedAiContext {
  courseId?: string;
  unitId?: string;
  lessonId?: string;
  level?: ScopedAiLevel;
  resourceId?: string;
  resourceKind?: 'link' | 'document' | 'slide' | 'file' | 'rubric';
}

interface UiState {
  isMobile: boolean;
  scopedAiPanelOpen: boolean;
  scopedAiContext: ScopedAiContext;
  navDrawerOpen: boolean;
}

const initialState: UiState = {
  isMobile: false,
  scopedAiPanelOpen: false,
  scopedAiContext: {},
  navDrawerOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
    toggleScopedAiPanel: (state) => {
      const opening = !state.scopedAiPanelOpen;
      state.scopedAiPanelOpen = opening;
      if (opening) {
        state.navDrawerOpen = false;
      }
    },
    openScopedAiPanel: (state) => {
      state.scopedAiPanelOpen = true;
      state.navDrawerOpen = false;
    },
    closeScopedAiPanel: (state) => {
      state.scopedAiPanelOpen = false;
    },
    setScopedAiContext: (state, action: PayloadAction<ScopedAiContext>) => {
      state.scopedAiContext = action.payload;
    },
    toggleNavDrawer: (state) => {
      const opening = !state.navDrawerOpen;
      state.navDrawerOpen = opening;
      if (opening) {
        state.scopedAiPanelOpen = false;
      }
    },
    closeNavDrawer: (state) => {
      state.navDrawerOpen = false;
    },
  },
});

export const {
  setIsMobile,
  toggleScopedAiPanel,
  openScopedAiPanel,
  closeScopedAiPanel,
  setScopedAiContext,
  toggleNavDrawer,
  closeNavDrawer,
} = uiSlice.actions;

export default uiSlice.reducer;
